import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import colors from 'styles/colors'
import { type AnalyticsContentStoriesCard } from 'types/api/analytic'

interface StoriesAnalyticsCardContentProps {
    card: AnalyticsContentStoriesCard
}
export function StoriesAnalyticsCardContent({
    card
}: StoriesAnalyticsCardContentProps) {
    const { t } = useTranslation()
    return (
        <CardContent>
            <CardCategories>
                {t('category')}{' '}
                <CategoryType>
                    {card.category.map(category => `${category.name} `)}
                    {card.category.length === 0 && t('none')}
                </CategoryType>
            </CardCategories>
            <ContentTypeWrapper>
                <ContentType>
                    {t('overallRevenue')} {'  '}
                    <Percentage>{card.overall_revenue}</Percentage>
                </ContentType>
            </ContentTypeWrapper>
        </CardContent>
    )
}

const CardContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

const CardCategories = styled.div`
    color: #afafaf;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 1.2rem;
    margin: 0.8rem 0;
`
const CategoryType = styled.span`
    color: ${colors.blueDark};
`
const ContentTypeWrapper = styled.div`
    display: flex;
`
const ContentType = styled.div`
    padding: 0.5rem;
    border-radius: 0.5rem;
    background: #e7e7e7;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 1.1rem;
    color: #828c94;
    width: auto;
`
const Percentage = styled.span`
    color: ${colors.blueLighter};
`
